module.exports = __webpack_public_path__ + "static/portillo_top_image-083c6ccfe7a72b90659735f08fb5a926.png";